import { render, staticRenderFns } from "./CreateFolderModal.vue?vue&type=template&id=adf039fc&scoped=true&"
import script from "./CreateFolderModal.vue?vue&type=script&lang=ts&"
export * from "./CreateFolderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf039fc",
  null
  
)

export default component.exports